import { Offer } from '../../services/exports/Interfaces';

// True when two offer lists represent the same offers in the same order.
//
// `setOffers` is `Object.assign(draft, payload)` with no equality check, so dispatching an
// equal-but-newly-allocated array still installs a new reference, re-renders every subscriber
// and re-runs every watcher effect keyed on it. With an offer that stays applied, BasketProvider's
// `items` memo also returns a fresh array (`result.map(handler.apply)`), so an unguarded dispatch
// closes a render loop: items -> eligibleOffers -> appliedOffers -> items. Watchers must compare
// before dispatching.
export const haveSameOffers = (a: Offer[] = [], b: Offer[] = []): boolean => {
  if (a.length !== b.length) {
    return false;
  }

  return a.every((offer, index) => offer?.id === b[index]?.id);
};
